import {noop} from '@benchling/js-utils';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GetAnalysisPipelineStep, getDataFrameSpecFromGetAnalysisDataFrame} from 'analysis-tool/AnalysisTypes';
import {assert} from 'Asserts';
import {
  isStepConfigEditorModalSupported,
  StepConfigEditorContents,
} from 'pipelines/generalized-step-config-editor/StepConfigEditorModal';
import {getPipelineStepConfig} from 'pipelines/StepShapeUtils';

import {MAX_POPOVER_HEIGHT, MAX_POPOVER_WIDTH} from './PopoverConstants';

export default function TransformPopoverContents({step}: {step: GetAnalysisPipelineStep}): JSX.Element {
  const {stepType, stepVersion} = step.definition;
  assert(isStepConfigEditorModalSupported(stepType, stepVersion), 'Unsupported step for transform popover');
  const config = getPipelineStepConfig(step, stepType, stepVersion);
  const inputDataFrameSpec = getDataFrameSpecFromGetAnalysisDataFrame(step.inputStepDatas[0].dataFrames[0]);

  return (
    <div className={css(styles.wrapper)}>
      <div className={css(styles.configEditor)}>
        <StepConfigEditorContents
          stepType={stepType}
          stepVersion={stepVersion}
          config={config}
          setConfig={noop}
          readOnly={true}
          inputDataFrameSpec={inputDataFrameSpec}
        />
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    padding: 10,
    width: MAX_POPOVER_WIDTH,
    maxHeight: MAX_POPOVER_HEIGHT,
  },
  configEditor: {
    width: MAX_POPOVER_WIDTH - 25,
  },
});
